import { APP_INITIALIZER, inject, LOCALE_ID, NgModule } from '@angular/core';
import { AppUpdateNoticeComponent } from './@shared/components/app-update-notice/app-update-notice.component';
import {
    HashLocationStrategy,
    LocationStrategy,
    PathLocationStrategy,
    registerLocaleData,
} from '@angular/common';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AppLayoutModule } from './layout/app.layout.module';
import { NotfoundComponent } from './demo/components/notfound/notfound.component';
import { ProductService } from './demo/service/product.service';
import { CountryService } from './demo/service/country.service';
import { CustomerService } from './demo/service/customer.service';
import { EventService } from './demo/service/event.service';
import { IconService } from './demo/service/icon.service';
import { NodeService } from './demo/service/node.service';
import { PhotoService } from './demo/service/photo.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouteReuseStrategy } from '@angular/router';
import {
    ApiPrefixInterceptor,
    ErrorHandlerInterceptor,
    RouteReusableStrategy,
} from './@shared';
import { TokenInterceptor } from './@shared/http/token-interceptor.service';
import { AuthenticatedInterceptor } from './@shared/http/authenticated-interceptor.service';
import { RuntimeConfigService, loadRuntimeConfig } from './@shared/runtime-config.service';
import {
    ConfigurationParameters,
    Configuration,
} from '@api-swagger-client/configuration';
import { environment } from '@env/environment';
import { DialogService } from 'primeng/dynamicdialog';
import { ApiModule } from '@api-swagger-client/index';
import { MessageService } from 'primeng/api';
import { BrowserModule } from '@angular/platform-browser';
import { StoreModule } from '@ngrx/store';
import { userFeature } from './store/user/user.reducer';
import { EffectsModule } from '@ngrx/effects';
import { UserEffects } from './store/user/user.effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideMessaging, getMessaging } from '@angular/fire/messaging';
import localeEs from '@angular/common/locales/es';

export function ApiClientConfigFactory() {
    const params: ConfigurationParameters = {
        basePath: `${(window as any).origin}${environment.serverUrl}`,
    };
    return new Configuration(params);
}

registerLocaleData(localeEs);
@NgModule({
    declarations: [AppComponent, NotfoundComponent],
    imports: [
        BrowserModule,
        StoreModule.forRoot({}),
        StoreModule.forFeature(userFeature),
        EffectsModule.forRoot([]),
        EffectsModule.forFeature([UserEffects]),
        AppRoutingModule,
        AppLayoutModule,
        ApiModule.forRoot(ApiClientConfigFactory),
        AppUpdateNoticeComponent,
    ],
    providers: [

        { provide: LOCALE_ID, useValue: 'es' },

        // Fase 3 (Infisical): traer del backend la configuración que hoy está
        // horneada en environment, antes de que arranque la app. Si falla, se
        // sigue con los valores locales; no bloquea el arranque.
        {
            provide: APP_INITIALIZER,
            useFactory: loadRuntimeConfig,
            deps: [RuntimeConfigService],
            multi: true,
        },

        // La factory se evalúa al primer inject de FirebaseApp, que ocurre
        // después del APP_INITIALIZER: para entonces la config ya llegó.
        provideFirebaseApp(() => initializeApp(inject(RuntimeConfigService).firebase)),
        provideMessaging(() => getMessaging()),

        { provide: LocationStrategy, useClass: PathLocationStrategy },
        CountryService,
        CustomerService,
        EventService,
        IconService,
        NodeService,
        PhotoService,
        ProductService,
        MessageService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ApiPrefixInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorHandlerInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthenticatedInterceptor,
            multi: true,
        },
        {
            provide: RouteReuseStrategy,
            useClass: RouteReusableStrategy,
        },
    ],
    bootstrap: [AppComponent],
})
export class AppModule { }
